import { router } from "@inertiajs/vue3";

// A page's JS chunk can fail to load: a deploy swapped public/build out from under an
// open tab, or a flaky mobile connection dropped the request (Safari reports both as
// "Importing a module script failed."). Inertia has already fetched the page JSON by
// then, so the visit just dies. A full load of the page the user was heading to
// fetches fresh assets and gets them there.
const RELOADED_AT_KEY = "chunk-reload-at";
const RELOAD_GUARD_MS = 10_000;

let targetUrl = null;

router.on("start", (event) => {
    const visit = event.detail.visit;
    if (visit.prefetch) {
        return;
    }
    targetUrl = visit.method === "get" ? visit.url.href : null;
});

function reloadedRecently() {
    try {
        return Date.now() - Number(sessionStorage.getItem(RELOADED_AT_KEY) ?? 0) < RELOAD_GUARD_MS;
    } catch {
        return false;
    }
}

function markReloaded() {
    try {
        sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
    } catch {
        // Without storage there is no loop guard, so don't risk a reload loop.
        return false;
    }
    return true;
}

// Wraps a page resolver so a failed chunk import turns into one hard navigation.
// If we already did that moments ago, the error is real: let it reach Sentry.
export function withChunkReload(resolve) {
    return (name) =>
        resolve(name).catch((error) => {
            if (reloadedRecently() || !markReloaded()) {
                throw error;
            }
            window.location.assign(targetUrl ?? window.location.href);
            // Leave Inertia waiting while the browser navigates away.
            return new Promise(() => {});
        });
}
